"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withCSRFebuiCheck = void 0;
const constants_1 = require("./constants");
const createCSRFTokenCheck_1 = require("./createCSRFTokenCheck");
exports.withCSRFebuiCheck = (0, createCSRFTokenCheck_1.createCSRFTokenCheck)({
    headerName: constants_1.HEADER_NAME,
    cookieName: constants_1.EB_UI_COOKIE_NAME,
    isSigned: false,
    deleteMismatchedCookie: false,
});
//# sourceMappingURL=withCSRFebuiCheck.js.map